import React, { ComponentType } from 'react';
import styled from '@emotion/styled';
import { Flex } from 'reflexbox';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../../components/Style/breakpoints';
import { FilterProps } from '../types';
import { OL_COLOUR_KELP } from '../../../../../components/Style/colours';

const Container = styled(Flex)`
  flex-direction: column;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
  }
`;

const Header = styled(Flex)`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #000000;
  padding: 12px;
  background: #fff;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
  }
`;

const StyledUL = styled.ul`
  list-style: none;
  padding: 12px;
  margin: 0;
  background: #f6f8f8;
  max-height: 220px;
  overflow: auto;
  overflow-x: hidden;
`;

const StyledLI = styled.li`
  padding: 6px 0;
`;

const StyledCheckbox = styled.div`
  width: 100%;
  position: relative;
  label {
    position: relative;
    width: 100%;
    min-height: 20px;
    display: block;
    padding-left: 30px;
    margin-bottom: 0;
    font-weight: normal;
    cursor: pointer;
    span {
      position: absolute;
      white-space: nowrap;
      top: 50%;
      transform: translateY(-50%);
      color: #3e4b4c;
    }
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      margin: 4px;
      width: 12px;
      height: 12px;
      transition: transform 0.28s ease;
      border-radius: 2px;
      border: 1px solid #b7bcbd;
    }
    &:after {
      content: '';
      display: block;
      width: 8px;
      height: 4px;
      border-bottom: 1px solid #fff;
      border-left: 1px solid #fff;
      transform: rotate(-45deg) scale(0);
      transition: transform ease 0.25s;
      position: absolute;
      top: 7px;
      left: 7px;
    }
  }
  input[type='checkbox'] {
    width: auto;
    opacity: 0.00000001;
    position: absolute;
    left: 0;
    margin-left: -20px;
    &:checked ~ label {
      &:before {
        border: 1px solid #058996;
        background: #058996;
      }
      &:after {
        transform: rotate(-45deg) scale(1);
      }
    }
    &:focus + label::before {
      outline: 0;
    }
  }
`;

const StyledText = styled.span`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 140%;
  color: #3e4b4c;
`;

const StyledLink = styled.span`
  font-family: Avenir;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 140%;
  color: ${OL_COLOUR_KELP};
  font-weight: 800;
  :hover {
    cursor: pointer;
  }
`;

export const Filter: ComponentType<FilterProps> = ({
  header,
  name,
  values,
  options,
  onChange,
}) => {
  // This ChangeEvent handler will call onChange with the updated filter values.
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const valueInValues =
      values instanceof Array ? values.indexOf(event.target.value) : -1;
    const newValues = values.slice(0);

    if (event.target.checked) {
      if (valueInValues === -1) {
        newValues.push(event.target.value);
      }
    } else {
      newValues.splice(valueInValues, 1);
    }
    onChange(newValues);
  };

  const isChecked = (value: string): boolean => {
    return values.indexOf(value) > -1;
  };

  const handleClearFilter = (): void => {
    onChange([]);
  };

  return (
    <Container>
      <Header>{header}</Header>
      <StyledUL>
        <StyledLI key={`item-clear-${name}`}>
          <StyledLink onClick={handleClearFilter}>Clear filters</StyledLink>
        </StyledLI>
        {options.map((option) => (
          <StyledLI key={`item-${option.value}`}>
            <StyledCheckbox>
              <input
                type="checkbox"
                id={`item-${option.value}`}
                name={name}
                value={option.value}
                checked={isChecked(option.value)}
                onChange={handleChange}
              />
              <label htmlFor={`item-${option.value}`}>
                <StyledText>{option.label}</StyledText>
              </label>
            </StyledCheckbox>
          </StyledLI>
        ))}
      </StyledUL>
    </Container>
  );
};
